import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { facebook, instagram, yelp, zomato } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="20px" column justifyStart>
          <CFView h3 futura bold color="#DEC397" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row center black bold>
            <CFLink
              target="_blank"
              href="https://www.facebook.com/SushiGioLangley"
            >
              <CFImage
                w="50px"
                pr="10px"
                src={facebook}
                alt="Sushi Gio Facebook"
              />
            </CFLink>
            <CFLink target="_blank" href="https://www.instagram.com/sushi.gio/">
              <CFImage
                w="50px"
                pr="10px"
                src={instagram}
                alt="Sushi Gio Instagram"
              />
            </CFLink>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          <CFView h3 futura bold color="#DEC397" mb="15px">
            SOCIAL MEDIA
          </CFView>
          <CFView row justifyStart black bold>
            <CFLink
              target="_blank"
              href="https://www.facebook.com/SushiGioLangley"
            >
              <CFImage
                w="45px"
                pr="10px"
                src={facebook}
                alt="Sushi Gio Facebook"
              />
            </CFLink>
            <CFLink target="_blank" href="https://www.instagram.com/sushi.gio/">
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Sushi Gio Instagram"
              />
            </CFLink>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
